import React from "react";
import FormattedDate from "shared/components/FormattedDate";
import {
  productApprovalRequested,
  productBlockedApproved
} from "shared/model-helpers/productHelper";
import Timer from "./timer.svg";

// TODO: REFACTOR -- RemainingTime is used by Merchant and by Startup side, but
// it should behave differently. Startup should be informed about pre-live state
// info of the product; but Merchant should never see this (he only sees live
// products)

export default function RemainingTime({ product }) {
  const blockedApproved = productBlockedApproved(product);
  const publishOn = productApprovalRequested(product)
    ? null
    : product.publishOn;

  if (blockedApproved) {
    return (
      <h5>
        <span
          className="glyphicon glyphicon-off product-information"
          aria-hidden="true"
        />
        On hold
      </h5>
    )
  }
  if (product.releasedByStartup === false) {
    return (
      <h5>
        <span
          className="glyphicon glyphicon-pencil product-information"
          aria-hidden="true"
        />
        In Bearbeitung
      </h5>
    );
  }
  return (
    <div>
      <img src={Timer} className="timer" alt="remaining time" />

      <FormattedDate date={publishOn} />
    </div>
  );
}
